import * as React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Row from 'reactstrap/lib/Row';
import { Col, Button } from 'reactstrap';
import { IMatch } from '../../../share/types/match';
import Label from 'reactstrap/lib/Label';
import { Map } from '../../Alert/Create/components/Map';
import { timestampToDateTimeString } from '../../../share/utils/utils';
import { IMapCenter } from 'src/share/types/common';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { IReduxState } from 'src/reduxTypes';
import { IAuthState, UserTypes } from 'src/modules/Auth/store/types';

export interface IImage {
    src: string;
    collection: string;
    box: {
        Left: number,
        Top: number;
        Height: number,
        Width: number
    };
    location?: IMapCenter
}
export interface IImageState extends IImage {
    width: number;
    height: number;
}
export interface IMatchDetailProps {
    auth: IAuthState;
    match: IMatch;
    deleteMatch?: (matchId) => () => void;
    onZoomImage: ({ source, boundingBoxes }) => void;
    deleting: boolean;
}

export interface IMatchDetailState {
    origin: IImageState;
    match: IImageState;
    showDelete: boolean;
}

export class MatchDetail extends React.Component<IMatchDetailProps, IMatchDetailState> {
    constructor(props: IMatchDetailProps) {
        super(props);
        const initial = {
            src: "",
            collection: "",
            width: 0,
            height: 0,
            box: {
                Left: 0,
                Top: 0,
                Height: 0,
                Width: 0
            }
        }
        this.state = {
            match: initial,
            origin: initial,
            showDelete: false
        }
        this.onProps(props);
    }
    public componentWillReceiveProps(props: IMatchDetailProps) {
        this.onProps(props)
    }
    public onProps(props: IMatchDetailProps) {
        const matchFace = props.match.matchFace;
        const originFace = props.match.originFace;
        const srcM: IImage = {
            collection: matchFace.collection,
            src: matchFace.url,
            box: matchFace.BoundingBox,
            location: matchFace.location
        }
        const srcO: IImage = {
            collection: originFace.collection,
            src: originFace.url,
            box: originFace.BoundingBox,
            location: originFace.location
        }
        const originImage = originFace.collection === "caseview-icmec" ? srcO : srcM;
        const matchImage = originFace.collection !== "caseview-icmec" ? srcO : srcM;
        this.loadImage(originImage, 'origin');
        this.loadImage(matchImage, 'match');
    }
    public loadImage(imageInfo: IImage, type: 'match' | 'origin') {
        const imageAlter: IImageState = { ..._.cloneDeep(imageInfo), height: 0, width: 0 }
        const image = new Image();
        image.src = imageAlter.src;
        image.onload = () => {
            imageAlter.height = image.height;
            imageAlter.width = image.width;
            Object.keys(imageAlter.box).forEach(key => imageAlter.box[key] = imageAlter.box[key] * 100)
            this.setState((state) => {
                return { ...state, [type]: imageAlter }
            })
        }
    }
    public modalToggle = () => {
        this.setState({ showDelete: !this.state.showDelete })
    }
    public isAdmin() {
        return this.props.auth.userType === UserTypes.ADMIN;
    }
    public render() {
        const { metadata, similarity, matchId } = this.props.match;
        const location = this.state.match.location || this.state.origin.location;
        const existLocation = location ? true : false;
        return (
            <Col md={12}>
                <Row>
                    <Col md={12} className={'imageContainer'}>
                        {this.renderImage(this.state.origin, true)}
                        {this.renderImage(this.state.match)}
                    </Col>
                    <Col md={12} className="stats-info">
                        <p><Label>Similarity:</Label>{similarity.toFixed(2)}/100.00</p>
                        <p><Label>Source:</Label>{metadata && metadata.url ? <span className="subFont">{metadata.url}</span> : "Data not available"}</p>
                        <p><Label>Image Date:</Label>{metadata && metadata.fetchTime ? timestampToDateTimeString(metadata.fetchTime) : "Data not available"}</p>
                    </Col>
                    <Col md={12} className={'mapContainer'}>
                        <Label />
                        <Map
                            center={existLocation ? location : { lat: 40.624305, lng: -74.849509 }}
                            marker={existLocation} zoomControl={existLocation} initialZoom={2}
                            noLocationData={!existLocation} />
                    </Col>
                </Row>
                {this.isAdmin() && this.props.deleteMatch &&
                    <Row>
                        <Col className="text-right" md={12}>
                            <Button className="btn-blue" onClick={() => this.modalToggle()}>
                                Discard
                        </Button>
                        </Col>
                    </Row>}
                <ConfirmationModal
                    isOpen={this.state.showDelete}
                    toggle={() => {
                        this.modalToggle();
                    }}
                    title={'Discard Match'}
                    description={this.props.deleting ? 'Discarding match...' : 'Are you sure you want to discard this match'}
                    onContinue={this.props.deleteMatch ? this.props.deleteMatch(matchId) : () => null}
                    loading={this.props.deleting}
                    showButtons={!this.props.deleting}
                />
            </Col>
        );
    }
    public renderImage(image: IImageState, first?) {
        const { src, box } = image;
        const collection = image.collection.split('-')
        const collectionName = collection.length > 0 ? collection.pop() as string : ""
        const boundStyle: React.CSSProperties = {
            position: 'absolute',
            width: `${box.Width}%`,
            height: `${box.Height}%`,
            top: `${box.Top}%`,
            left: `${box.Left}%`,
            boxShadow: `${collectionName === 'webiq' ? '0 0 78px 100vh rgba(245, 248, 250, 0.97)' : 'none'}`
        }
        let maxHeight = this.state.match.height > this.state.origin.height ?
            this.state.origin.height : this.state.match.height
        maxHeight = maxHeight > 250 ? 250 : maxHeight
        const containerStyle = Object.assign({ height: image.height, maxHeight, display: 'inline-block', position: 'relative' });
        return (
            <div className="col-xs-12" style={containerStyle}>
                <Label className="subFont">{collectionName.toUpperCase()}</Label>
                <div className="container-img" onClick={() => this.props.onZoomImage({ source: src, boundingBoxes: [{ box: { ...boundStyle } }] })}>
                    <img src={src} style={{ maxHeight: 250 }} />
                    <div className="bounding-box" style={boundStyle} />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});
export default connect(mapStateToProps)(MatchDetail);
